<template>
  <ul>
    <div class="tw-text-gray-600 tw-mb-1">Your Home Location</div>
    <li class="tw-border tw-rounded-md tw-py-4 tw-px-6">
      <div class="tw-flex tw-items-center tw-justify-between">
        <div>
          <div>{{ homeLocation.name }}</div>
          <div class="tw-text-gray-600 tw-text-sm">{{ address(homeLocation) }}</div>
          <div class="tw-text-gray-600 tw-text-sm">{{ homeLocation.city }}, {{ homeLocation.state }} {{ homeLocation.zip }}</div>
        </div>
        <base-button type="secondary" class="tw-rounded-full tw-pl-2 tw-pr-2" @click="mapsSelector(homeLocation)"><map-icon class="tw-h-5 tw-w-5"/></base-button>
      </div>
    </li>
    <div class="tw-text-gray-600 tw-mb-1 tw-mt-10">Other Locations</div>
    <li
      v-for="location in locations.filter((location) => location.businessLocationId !== homeLocation.businessLocationId)"
      :key="location.businessLocationId"
      class="tw-border tw-rounded-md tw-py-4 tw-px-6"
    >
      <div class="tw-flex tw-items-center tw-justify-between">
        <div>
          <div>{{ location.name }}</div>
          <div class="tw-text-gray-600 tw-text-sm">{{ address(location) }}</div>
          <div class="tw-text-gray-600 tw-text-sm">{{ location.city }}, {{ location.state }} {{ location.zip }}</div>
        </div>
        <base-button type="secondary" class="tw-rounded-full tw-pl-2 tw-pr-2" @click="mapsSelector(location)"><map-icon class="tw-h-5 tw-w-5"/></base-button>
      </div>
    </li>
  </ul>
</template>
<script>
import { MapIcon } from "@/assets/svgs";

export default {
  components: {
    MapIcon,
  },
  props: {
    businessName: String,
    locations: Array,
    homeLocation: Object,
  },
  methods: {
    mapsSelector(location) {
      let street = location.line2 === "" ? location.line1 : location.line1 + ", " + location.line2;
      const encodedAddress = encodeURIComponent(street + " " + location.city + " " + location.state + " " + location.zip);

      if (
        /* if we're on iOS, open in Apple Maps */
        navigator.platform.indexOf("iPhone") != -1 ||
        navigator.platform.indexOf("iPad") != -1 ||
        navigator.platform.indexOf("iPod") != -1
      )
        window.open("http://maps.apple.com/?daddr=" + encodedAddress);
      /* else use Google */ else window.open("https://maps.google.com/maps/dir/?api=1&destination=" + encodedAddress);
    },
    address(location) {
      return location.line2 && location.line2.length > 0 ? location.line1 + ", " + location.line2 : location.line1;
    },
  },
};
</script>
